import type { gsap as Gsap } from 'gsap';
import type { ScrollTrigger as ST } from 'gsap/ScrollTrigger';

type MatchMedia = ReturnType<typeof Gsap['matchMedia']>;
export type Timeline = gsap.core.Timeline;
export type Tween = gsap.core.Tween;
export type GSAP = typeof Gsap;
export type ScrollTrigger = typeof ST;

let gsap: typeof Gsap;
let scrollTrigger: ScrollTrigger
let matchMedia: MatchMedia

const queue: ((gsap: typeof Gsap, scrollTrigger: typeof ST) => void)[] = [];
const mmQueue: { mediaQuery: string; callback: () => void }[] = [];

import('@/utils/gsap').then(
  ({ gsap: g, ScrollTrigger }) => {
    gsap = g;
    scrollTrigger = ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);
    matchMedia = gsap.matchMedia();

    queue.forEach((callback) => {
      callback(gsap, scrollTrigger);
    });

    mmQueue.forEach(({ mediaQuery, callback }) => {
      matchMedia.add(mediaQuery, callback);
    });
  },
);

export function getGsap(callback: (gsap: typeof Gsap, scrollTrigger: typeof ST) => void) {
  if (gsap && scrollTrigger) {
    callback(gsap, scrollTrigger);
  } else {
    queue.push(callback);
  }
}

export function getGsapMM(mediaQuery: string, callback: () => void) {
  if (matchMedia) {
    matchMedia.add(mediaQuery, callback);
  } else {
    mmQueue.push({ mediaQuery, callback });
  }
}
